import React from 'react'
import PropTypes from 'prop-types'
import { isEmpty, uniqBy } from 'lodash'

import './OccupancyTooltip.scss'
import { occupancyDataKeySuffix } from '../../../../../utils/kpiUtils'

/**
 * Groups payload data by name.
 * Data is formatted in kpiUtils to include suffixes for working/non-working hours
 */
const formatPayloadData = data => {
  return uniqBy(
    data.map(p => ({
      name: p.name,
      color: p.fill,
      workingHours: p.payload[`${p.name}${occupancyDataKeySuffix.workingHours}`],
      nonWorkingHours: p.payload[`${p.name}${occupancyDataKeySuffix.nonWorkingHours}`],
      total: p.payload[`${p.name}`]
    })),
    'name'
  )
}

const OccupancyTooltip = props => {
  const { active, payload = [], label } = props
  if (!active || isEmpty(payload)) {
    return null
  }

  return (
    <div className="kpi-occupancy-tooltip">
      <div className="label">{label}</div>
      <table>
        <thead>
          <tr>
            <th />
            <th>Working Hours</th>
            <th>Non-working Hours</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          {formatPayloadData(payload).map(data => (
            <tr key={data.name}>
              <th scope="row">
                <i className={`fa fa-circle`} style={{ color: data.color, paddingRight: '2px' }} />
                <span>{data.name}</span>
              </th>
              <td>{data.workingHours || 0}%</td>
              <td>{data.nonWorkingHours || 0}%</td>
              <td>{data.total || 0}%</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

OccupancyTooltip.propTypes = {
  type: PropTypes.string,
  payload: PropTypes.array,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  active: PropTypes.bool,
  showTotal: PropTypes.bool,
  productColors: PropTypes.object,
  labelSuffix: PropTypes.string
}

export default OccupancyTooltip
